/*!
 * KoliBri - The accessible HTML-Standard
 */
import { r as registerInstance, h, H as Host, g as getElement } from './index-C_ZKddLG.js';
import { B as BaseWebComponent } from './base-web-component-D909Fl-Y.js';
import { T as TooltipBehavior } from './behavior-Co00uT-D.js';
import { T as TooltipFC } from './component-BXCnkVUN.js';
import './common-D-vggmh2.js';
import './align-floating-elements-CBhVmYjn.js';
import './tooltip-open-tracking-D3tCiiGP.js';
import './normalizers-BNeak4hj.js';
import './_Uint8Array-kJHDjtoP.js';
import './isArray-CcrBs4JM.js';
import './align-C8fl12z_.js';
import './label-FtX-skKy.js';
import './label-w3T7Y2ih.js';
import './variant-quote-ClYWonZq.js';
import './component-DepnuZGT.js';
import './tslib.es6-QNbPBOk5.js';
import './bem-registry-3ondDImf.js';
import './clsx-COFh-Vc8.js';
import './component-BjVFpeYY.js';

const KolTooltipWc = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.tooltipBehavior = new TooltipBehavior(BaseWebComponent.stateLess);
        this._align = 'top';
    }
    validateAlign(value) {
        var _a;
        (_a = this.tooltipBehavior) === null || _a === void 0 ? void 0 : _a.watchAlign(value);
    }
    validateId(value) {
        var _a;
        (_a = this.tooltipBehavior) === null || _a === void 0 ? void 0 : _a.watchId(value);
    }
    validateLabel(value) {
        var _a;
        (_a = this.tooltipBehavior) === null || _a === void 0 ? void 0 : _a.watchLabel(value);
    }
    hideTooltip() {
        var _a;
        return Promise.resolve((_a = this.tooltipBehavior) === null || _a === void 0 ? void 0 : _a.hideTooltip());
    }
    componentWillLoad() {
        this.tooltipBehavior.componentWillLoad({
            label: this._label,
            align: this._align,
            badgeText: this._badgeText,
            id: this._id,
        });
    }
    connectedCallback() {
        var _a, _b, _c;
        (_a = this.tooltipBehavior) === null || _a === void 0 ? void 0 : _a.initContext(((_c = (_b = this.host) === null || _b === void 0 ? void 0 : _b.previousElementSibling) !== null && _c !== void 0 ? _c : undefined));
    }
    componentDidRender() {
        var _a;
        if (this.host) {
            (_a = this.tooltipBehavior) === null || _a === void 0 ? void 0 : _a.handleEventListeners(this.host);
        }
    }
    disconnectedCallback() {
        var _a;
        (_a = this.tooltipBehavior) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    render() {
        return (h(Host, { key: '24188cfa0cc3e2db0e15bb13d42dbfb391980ece', class: "kol-tooltip" }, h(TooltipFC, { key: '599e639e86ce70effba916d9736e0428ad1b7e84', label: this.tooltipBehavior.getRenderProp('label'), badgeText: this._badgeText, id: this.tooltipBehavior.getRenderProp('id'), refFloating: (el) => { var _a; return (_a = this.tooltipBehavior) === null || _a === void 0 ? void 0 : _a.setTooltipElementRef(el); } })));
    }
    get host() { return getElement(this); }
    static get watchers() { return {
        "_align": ["validateAlign"],
        "_id": ["validateId"],
        "_label": ["validateLabel"]
    }; }
};

export { KolTooltipWc as kol_tooltip_wc };
//# sourceMappingURL=kol-tooltip-wc.entry.js.map
